import { reportGetReportsRequest } from '@/modules/report/reportActions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

type GetReportsProps = {
	startDate: Date;
	endDate: Date;
	userEmail: string | string[];
	listId?: string;
	method?: string;
	listName?: string;
	locationId?: string;
};

export const useReportsQuery = () => {
	const dispatch = useDispatch();

	const getReports = useCallback(
		(props: GetReportsProps) => {
			return dispatch(reportGetReportsRequest(props));
		},
		[dispatch]
	);

	return { getReports };
};
